import { render, staticRenderFns } from "./customerCount.vue?vue&type=template&id=521a7941&scoped=true&"
import script from "./customerCount.vue?vue&type=script&lang=js&"
export * from "./customerCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a7941",
  null
  
)

export default component.exports